import { generatePath } from 'react-router-dom';
import { useHistory, useLocation, useParams } from 'react-router-dom';

const useReplaceUrlParam = (pattern: string) => {
  const params = useParams<Record<string, string>>();
  const history = useHistory();
  const location = useLocation();

  const replaceUrlParam = (paramToReplace: string, newValue: string) => {
    const newPath = generatePath(pattern, {
      ...params,
      [paramToReplace]: newValue,
    });

    history.replace({
      pathname: newPath,
      search: location.search,
    });
  };

  return replaceUrlParam;
};

export default useReplaceUrlParam;
